import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import ShiftPolicyForm from "Components/Form/ShiftPolicyForm";
import {
  useGetShiftPolicyByIdQuery,
  useUpdateShiftPolicyMutation,
} from "AppQuries/shift/policy/shift-policy";
import { shiftPolicyValidation } from "core/Operations/ValidationSchema/shiftValidation";
import { tr } from "date-fns/locale";
import { toast } from "core/Operations/toast";
import { getCurrentFormattedDate } from "core/Operations/dateFormat";
import dayjs from "dayjs";
import useTimeConverter from "core/Operations/useTimeConverter";
import { BackIcon } from "Components/UI/Icon/Icons";
const EditShiftPolicy = () => {
  const userData = useSelector(loggedInUser);
  const { timeStringToFloat, floatToTimeString } = useTimeConverter();
  const { code } = useParams();
  const {
    data: shiftPolicyData,
    isLoading,
    isError: isFetchingError,
    error: fetchingError,
    isFetching,
  } = useGetShiftPolicyByIdQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    code,
  });

  console.log(shiftPolicyData);
  const {
    mutate: updateShiftPolicy,
    isPending,
    isError,
    error,
  } = useUpdateShiftPolicyMutation();
  const methods = useForm({
    resolver: yupResolver(shiftPolicyValidation),
  });

  const { setValue, watch } = methods;

  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors },
  } = methods;

  console.log("errors", errors);

  const onSubmit = (payload) => {
    payload.modifyUser = userData.userName;
    payload.modifyDate = getCurrentFormattedDate();
    updateShiftPolicy(payload, {
      onSuccess: (data) => {
        console.log(data);
        if (data === true) {
          toast.success("Shift Policy Updated Successfully.");
          // setTimeout(() => {
          navigate(`${all_routes.shift}${all_routes.shift_policy}`);
          // }, 1000);
        } else {
          toast.warning("Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  const [settingValues, setSettingValues] = useState(false);
  useEffect(() => {
    setSettingValues(true);
    if (Array.isArray(shiftPolicyData) && shiftPolicyData.length > 0) {
      Object.keys(shiftPolicyData[0]).forEach((key) => {
        setValue(key, shiftPolicyData[0][key]);
        // if (key === "otMinimumHours" || key === "otRoundOffMinimum") {
        //   console.log("setting time values", shiftPolicyData[0][key]);
        //   const value =
        //     shiftPolicyData[0][key] !== 0
        //       ? dayjs(
        //           floatToTimeString({ float: shiftPolicyData[0][key] }),
        //           "HH:mm"
        //         )
        //       : null;

        //   setValue(key, value);
        // }
      });
    }
    setSettingValues(false);
  }, [shiftPolicyData]);
  if (isError) return <Error404 error={error} />;
  if (isFetchingError) return <Error404 error={fetchingError} />;
  if (isLoading || isPending || isFetching || settingValues)
    return <LoadingSpinner />;
  return (
    <div className="page-wrapper">
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="content">
            <div className="page-header">
              <div className="add-item d-flex">
                <div className="page-title">
                  <h4>Edit Shift Policy</h4>
                  <h6>Edit your Shift Policy </h6>
                </div>
              </div>

              <div className="page-btn">
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="add-new-tooltip">Update Shift Policy</Tooltip>
                  }
                >
                  <button type="submit" className="btn btn-added">
                    <Save className="me-2" />
                    Update
                  </button>
                </OverlayTrigger>
              </div>
              <div className="page-btn">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                >
                  <Link
                    to={`${all_routes.shift}${all_routes.shift_policy}`}
                    className="btn btn-secondary"
                  >
                    <BackIcon className="me-2" />
                    Back
                  </Link>
                </OverlayTrigger>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card border-0">
                  <div className="card-header">
                    <h4 className="card-title">Edit Shift Policy</h4>
                  </div>
                  <div className="card-body">
                    {watch("companyCode") ? (
                      <ShiftPolicyForm />
                    ) : (
                      <LoadingSpinner />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default EditShiftPolicy;
